import React, { Component } from "react";

import axios from "axios";

import schema from "./schema";
import { DOMAIN } from "config/config";

import Formizo from "Components/LabIZO/Formizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { Accessor, ErrorX, store } from "static";

class SysDefaultMessages extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      defaultMessageDocs: undefined,
    };
  }

  componentDidMount() {
    this._setAllStates(() => {
      this._getDefaultMessages();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(SysDefaultMessages.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  DefaultMessages = {
    _onSubmit: async (data) => {
      let link = "/Tables/Answer/Edit";
      let url = DOMAIN + link;

      data.welcomeDoc_morning.text = Object.entries(data.welcomeDoc_morning.text).reduce((acc, [key, value]) => {
        acc[key] = typeof value === "string" ? [value] : value;
        return acc;
      }, {});
      data.welcomeDoc_afternoon.text = Object.entries(data.welcomeDoc_afternoon.text).reduce((acc, [key, value]) => {
        acc[key] = typeof value === "string" ? [value] : value;
        return acc;
      }, {});
      data.welcomeDoc_evening.text = Object.entries(data.welcomeDoc_evening.text).reduce((acc, [key, value]) => {
        acc[key] = typeof value === "string" ? [value] : value;
        return acc;
      }, {});
      data.noanswerDoc.text = Object.entries(data.noanswerDoc.text).reduce((acc, [key, value]) => {
        acc[key] = typeof value === "string" ? [value] : value;
        return acc;
      }, {});

      let welcomeMorningPayloadOut = {
        data: {
          ...data.welcomeDoc_morning,
        },
        JWT: store.user.JWT,
      };
      let welcomeAfternoonPayloadOut = {
        data: {
          ...data.welcomeDoc_afternoon,
        },
        JWT: store.user.JWT,
      };
      let welcomeEveningPayloadOut = {
        data: {
          ...data.welcomeDoc_evening,
        },
        JWT: store.user.JWT,
      };
      let noanswerPayloadOut = {
        data: {
          ...data.noanswerDoc,
        },
        JWT: store.user.JWT,
      };

      try {
        console.log(link, welcomeMorningPayloadOut, welcomeAfternoonPayloadOut, welcomeEveningPayloadOut, noanswerPayloadOut);

        store.isLoading(true);
        let res0 = await axios.post(url, welcomeMorningPayloadOut);
        let res1 = await axios.post(url, welcomeAfternoonPayloadOut);
        let res2 = await axios.post(url, welcomeEveningPayloadOut);
        let res3 = await axios.post(url, noanswerPayloadOut);
        store.isLoading(false);

        console.log(link, res0.data, res1.data, res2.data, res3.data);

        if (res0.data.Success && res1.data.Success && res2.data.Success && res3.data.Success) {
          this.DefaultMessages.onSuccess();
        } else {
          this.DefaultMessages.onFail("System default message update fails.");
        }
      } catch (e) {
        this.DefaultMessages.onFail(ErrorX.Handle(e));
      }
    },

    onSuccess: () => {
      store.Alert("System default message updated successfully", "success");
      this._getDefaultMessages();
    },

    onFail: (msg) => {
      store.isLoading(false);
      store.Alert(msg, "error");
    },
  };

  _getDefaultMessages = async () => {
    let link = "/Tables/Answer/List";
    let url = DOMAIN + link;
    let payloadOut = {
      JWT: store.user.JWT,
      data: {},
    };

    try {
      console.log(link, payloadOut);

      store.isLoading(true);
      let res = await axios.post(url, payloadOut);
      store.isLoading(false);

      console.log(link, res.data);

      let { Success, payload } = res.data;

      if (Success) {
        let welcomeDoc_morning = payload.docs.filter((doc) => doc._id === "master:WELCOME_MORNING")[0];
        let welcomeDoc_afternoon = payload.docs.filter((doc) => doc._id === "master:WELCOME_AFTERNOON")[0];
        let welcomeDoc_evening = payload.docs.filter((doc) => doc._id === "master:WELCOME_EVENING")[0];
        let noanswerDoc = payload.docs.filter((doc) => doc._id === "master:NOANSWER")[0];
        let defaultMessageDocs = {
          welcomeDoc_morning: welcomeDoc_morning,
          welcomeDoc_afternoon: welcomeDoc_afternoon,
          welcomeDoc_evening: welcomeDoc_evening,
          noanswerDoc: noanswerDoc,
        };
        this.setState({
          defaultMessageDocs: defaultMessageDocs,
        });
      } else {
        store.Alert(payload, "error");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  renderForm() {
    let { defaultMessageDocs } = this.state;
    if (defaultMessageDocs === undefined) return;

    let defaultValue = {
      ...defaultMessageDocs,
    };
    return <Formizo height="100%" schema={schema.defaultMessage} buttons={["Revert", "Submit"]} onSubmit={this.DefaultMessages._onSubmit} defaultValue={defaultValue} />;
  }

  render() {
    return <VStack height="100%">{this.renderForm()}</VStack>;
  }
}

export default SysDefaultMessages;
